var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayAdditionalShopForm)?_c('div',{staticClass:"remove-shop-form"},[_c('ui-button',{attrs:{"type":"link-blue","active":true,"disabled":_vm.removingShop},on:{"click":_vm.removeShop}},[_vm._v(" Remove this shop ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }